// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"RegisterPage_formContainer__1lIaU","formRow":"RegisterPage_formRow__2bm1-","error":"RegisterPage_error__17-zZ","loginLink":"RegisterPage_loginLink__qCeai"};